module.exports = __webpack_public_path__ + "static/media/eminetarininstagram.0b4a9156.jpg";